/* unplugin-vue-components disabled */import script from "./supplier-user-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./supplier-user-modal.vue?vue&type=script&setup=true&lang=js"

import "./supplier-user-modal.vue?vue&type=style&index=0&id=4f1a7ef2&lang=scss"

const __exports__ = script;

export default __exports__